import { IRSW2Form, validateLocalWithholding } from "../model/tax/irsw2.d";
import { TaxDocument } from "../model/tax/tax_document";

/*
 * Common method used to determine whether or not
 * local withholdings are present on a W2
 */
export const detectMissingLocalWithholdings = (irsW2: TaxDocument<IRSW2Form>): boolean => {
  const lwh = irsW2.form_data.local_withholdings;
  return (!lwh || !lwh.length || 
      lwh.some((l) => !l.local_income_tax && !l.local_wages_and_tips && l.locality_name) ||
      lwh.some((l) => l.local_income_tax && l.local_wages_and_tips && !l.locality_name));
}

export const detectMissingBox18 = (irsW2: TaxDocument<IRSW2Form>): boolean => {
  const lwh = irsW2.form_data.local_withholdings;
  return lwh?.some((l) => validateLocalWithholding(l) &&
    (!!l.local_income_tax || !!l.locality_name) && !l.local_wages_and_tips) || false;
}